/**
 * App-wide access to the MSAL bearer token outside the Axios interceptor.
 *
 * `index.tsx` registers the provider it builds for Axios; code that has to use
 * `fetch` directly (streamed responses cannot go through Axios) acquires the
 * same token here so both transports share one cache and one refresh flow.
 */
export type AccessTokenProvider = () => Promise<string>;

let registeredProvider: AccessTokenProvider | null = null;

export const registerAccessTokenProvider = (provider: AccessTokenProvider | null): void => {
  registeredProvider = provider;
};

export const acquireAccessToken = (): Promise<string> => {
  if (!registeredProvider) {
    return Promise.reject(new Error('Access token provider is not registered.'));
  }

  return registeredProvider();
};
